import { HealthDto, PingJobDto } from "@growth/dto";
import { useMutation, useQuery } from "@tanstack/react-query";

import { api } from "./api";

/** Health answers 503 with the same body when the database is down, so read it either way. */
export const useHealth = () =>
  useQuery({
    queryKey: ["health"],
    queryFn: async () =>
      (await api.get<HealthDto>("/health", { validateStatus: (status) => status < 600 })).data,
    refetchInterval: 10_000,
  });

export const useStartPing = () =>
  useMutation({
    mutationFn: async (note: string) =>
      (await api.post<PingJobDto>("/jobs/ping", { note: note.trim() || null })).data,
  });

const settled = (job: PingJobDto | undefined) =>
  job?.state === "completed" || job?.state === "failed";

/** Polls a ping job every half second until the worker finishes it (or gives up). */
export const usePingJob = (id: string | null) =>
  useQuery({
    queryKey: ["jobs", "ping", id],
    enabled: id !== null,
    queryFn: async () => (await api.get<PingJobDto>(`/jobs/ping/${id}`)).data,
    refetchInterval: (query) => (settled(query.state.data) ? false : 500),
  });
